import React, { memo } from 'react';

const ChartCard = memo(({ title, subtitle, children, className = 'col-span-12 lg:col-span-4', insight }) => (
  <div className={className}>
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden h-full flex flex-col">
      <div className="px-4 py-3 border-b border-gray-50 flex items-center justify-between flex-shrink-0">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-gray-800 truncate">{title}</h3>
          {subtitle && <p className="text-xs text-gray-400 mt-0.5 truncate">{subtitle}</p>}
        </div> 
         
        {insight && (
          <span className="ml-3 text-xs font-semibold px-2.5 py-1 bg-indigo-50 text-indigo-600 rounded-full whitespace-nowrap flex-shrink-0">
            {insight}
          </span>
        )}
      </div>
      <div className="p-4 flex-1">
        {children}
      </div>
    </div>
  </div>
));

export default ChartCard;
